/** @fileoverview Per-KPI energy-source dropdown with a clear button. */

/**
 * Dropdown to assign an energy source to a KPI.
 * @param {object} props Component props.
 * @param {Array<{id:number,name:string}>} props.sources Available energy sources.
 * @param {number|null} props.value Currently assigned source id.
 * @param {(sourceId:number|null)=>void} props.onChange Assignment change handler.
 * @param {boolean} [props.compact] Compact sizing for inline rows.
 * @param {boolean} [props.disabled] Disable interaction.
 * @returns {JSX.Element} The source picker.
 */
export default function SourcePicker({ sources, value, onChange, compact = false, disabled = false }) {
  if (!sources || sources.length === 0) {
    return <span style={{ fontSize: 10, color: "var(--es-slate-300)", fontStyle: "italic" }}>no sources</span>;
  }
  const hasValue = !!value;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 3 }} onClick={e => e.stopPropagation()}>
      <select
        className="es-select"
        value={value ?? ""}
        disabled={disabled}
        onChange={e => onChange(e.target.value ? Number(e.target.value) : null)}
        style={{
          padding: compact ? "3px 6px" : "5px 10px",
          borderRadius: 6,
          border: `1.5px solid ${hasValue ? "var(--es-amber-300)" : "var(--es-slate-200)"}`,
          fontSize: compact ? 10 : 11,
          color: hasValue ? "var(--es-source)" : "var(--es-slate-400)",
          background: hasValue ? "var(--es-amber-50)" : "var(--es-white)",
          cursor: disabled ? "not-allowed" : "pointer",
          maxWidth: compact ? 130 : 190,
          fontWeight: hasValue ? 600 : 400,
          paddingRight: compact ? 16 : 20,
        }}
      >
        <option value="">Assign Source…</option>
        {sources.map(src => (
          <option key={src.id} value={src.id}>{src.name}</option>
        ))}
      </select>
      {hasValue && !disabled && (
        <button
          className="es-x-btn"
          onClick={e => { e.stopPropagation(); onChange(null); }}
          style={{ fontSize: 12, border: "none", background: "none", cursor: "pointer", padding: "0 2px", fontWeight: 900, lineHeight: 1 }}
        >×</button>
      )}
    </div>
  );
}
